import React from 'react';
import { RadioGroup } from 'components';
import { RadioGroupProps } from 'antd/lib/radio';

type FormTypeRadioProps = RadioGroupProps;

const OPTIONS = [
  {
    value: 'client',
    label: 'Client',
  },
  {
    value: 'supplier',
    label: 'Supplier',
  },
];

const FormTypeRadio: React.FC<FormTypeRadioProps> = ({
  onChange,
  value,
  ...props
}) => (
    <RadioGroup
      buttonStyle="solid"
      onChange={onChange}
      options={OPTIONS}
      optionType="button"
      value={value}
      {...props}
    />
  );

export default FormTypeRadio;
